<template>
  <div class="q-mt-lg">
    <div
      class="row col-12 q-ml-lg justify-between items-center q-mt-md q-mb-sm text-brand-1 text-weight-medium"
      style="font-size: 16px"
    >
      <span>Todos os Produtos em Aberto</span>

      <q-btn
        @click="exportar"
        class="q-ml-sm"
        icon="file_upload"
        label="Exportar"
        style="border-radius: 8px; background-color: #304f78; color: white"
        no-caps
      />
    </div>
    <q-table
      flat
      table-header-style="background-color: #d9effc"
      :rows="rows"
      :columns="columns"
      :loading="disable"
      :filter="filtrar"
      color="primary"
      title-class="text-brand-5 text-weight-bold"
      class="tabela-tamanho-fixo"
      hide-pagination
      dense
      v-model:pagination="pagination"
      :rows-per-page-options="[0]"
      @request="handleRequest"
    >
      <template v-slot:body="props">
        <q-tr
          :class="{ 'bg-green-2': props.row.purchase_order_id }"
          class="text-brand-5 text-weight-bold"
          :props="props"
        >
          <q-td>
            <router-link
              style="text-decoration: none; color: blue"
              :to="{ name: 'compras-detalhe', params: { id: props.row.uuid } }"
            >
              <span>{{ props.row.numero }}</span>
            </router-link>
          </q-td>
          <q-td>
            {{
              props.row.created_at.split(" ")[0].split("-").reverse().join("/")
            }}
          </q-td>
          <q-td>
            {{ props.row.solicitante_nome }}
          </q-td>
          <q-td>
            {{ props.row.responsavel_nome }}
          </q-td>
          <q-td>
            {{ props.row.produto_nome }}
          </q-td>
          <q-td>
            {{ props.row.product_codigo }}
          </q-td>
          <q-td>
            {{ formatQuantidade(props.row.quantidade_necessaria) }}
          </q-td>
          <q-td>
            {{ props.row.unidade_medida_necessidade }}
          </q-td>
          <q-td>
            <div v-if="props.row.purchase_order_id">
              <router-link
                style="text-decoration: none; color: blue"
                :to="{
                  name: 'compras-editar',
                  params: { id: props.row.purchase_order_id },
                }"
              >
                <span>{{ `PED - ${props.row.purchase_order_id}` }}</span>
              </router-link>
            </div>
            <span v-else>Não</span>
          </q-td>
          <q-td>
            {{ props.row.status_pedido }}
          </q-td>
        </q-tr>
      </template>
    </q-table>
    <div class="row justify-center q-mt-md">
      <q-pagination
        :disable="disable"
        v-model="pagination.page"
        color="brand-5"
        active-color="secondary"
        active-text-color="white"
        :max="pagesNumber"
        :max-pages="5"
        :boundary-numbers="false"
        :direction-links="true"
        size="sm"
      />
    </div>
  </div>
</template>

<script>
const formatQuantidade = (value) => {
  if (!value && value !== 0) return "0,0000";
  const num = Number(String(value).replace(",", "."));
  if (isNaN(num)) return "0,0000";

  return new Intl.NumberFormat("pt-BR", {
    minimumFractionDigits: 4,
    maximumFractionDigits: 4,
  }).format(num);
};

const columns = [
  {
    name: "numero",
    label: "Necessidade #",
    field: "numero",
    align: "left",
  },
  {
    name: "created_at",
    label: "Criada em",
    field: "created_at",
    align: "left",
  },
  {
    name: "solicitante_nome",
    label: "Solicitante",
    field: "solicitante_nome",
    align: "left",
  },
  {
    name: "responsavel_nome",
    label: "Responsável",
    field: "responsavel_nome",
    align: "left",
  },
  {
    name: "produto_nome",
    label: "Produto",
    field: "produto_nome",
    align: "left",
  },

  {
    name: "product_codigo",
    label: "Codigo",
    field: "product_codigo",
    align: "left",
  },

  {
    name: "quantidade_necessaria",
    label: "Qtd. de Compra",
    field: "quantidade_necessaria",
    align: "left",
  },

  {
    name: "unidade_medida_necessidade",
    label: "Unid. Medida",
    field: "unidade_medida_necessidade",
    align: "left",
  },

  {
    name: "purchase_order_id",
    label: "Ped. Compra",
    field: (row) =>
      row.purchase_order_id ? "Ped" + " " + row.purchase_order_id : "Não",
    align: "left",
  },

  {
    name: "status_pedido",
    label: "Status Pedido",
    field: "status_pedido",
    align: "left",
  },
];

import { ref, onMounted, watch, computed } from "vue";
import { useStore } from "vuex";
import { useQuasar } from "quasar";
export default {
  props: ["atualizar", "Responsavel", "Produto", "Solicitante", "filtros"],
  setup(props) {
    const store = useStore();
    const $q = useQuasar();
    const rows = ref([]);
    const disable = ref(false);
    const filtrar = ref("");
    const compra = ref("Todos");

    const pagination = ref({
      sortBy: "desc",
      descending: false,
      page: 1,
      rowsPerPage: 15,
      rowsNumber: 15,
    });

    const getDados = async (page = 1, rowsPerPage = 15) => {
      disable.value = true;
      try {
        const response = await store.dispatch("compras/produtosAbertos", {
          vendor_id: store.state.org.unidadeData.id,
          page,
          per_page: rowsPerPage,
          produto:
            props.filtros?.produto == "" ? undefined : props.filtros?.produto,
          responsavel: props.filtros?.responsavel?.sap,
          user:
            props.filtros?.solicitante == ""
              ? undefined
              : props.filtros?.solicitante,
          data_inicial: props.filtros?.dataInicial,
          data_final: props.filtros?.dataFinal,
          comprado: props.filtros.compra?.value,
          com_comprador: props.filtros.comprador?.value,
          numero:
            props.filtros?.numeroNecessidade == ""
              ? undefined
              : props.filtros?.numeroNecessidade,
        });

        rows.value = response.data.data;

        pagination.value.rowsPerPage = response.data.per_page;
        pagination.value.rowsNumber = response.data.total;
        pagination.value.page = response.data.current_page;
        disable.value = false;
      } catch (error) {
        disable.value = false;
        $q.notify({
          message: "Erro a o encontrar dados",
          color: "negative",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
      }
    };

    onMounted(getDados);

    const handleRequest = async () => {
      getDados(pagination.value.page, pagination.value.rowsPerPage);
    };

    const exportar = async () => {
      try {
        await store.dispatch("compras/produtosAbertosExport", {
          vendor_id: store.state.org.unidadeData.id,
          produto: props.filtros?.produto,
          responsavel: props.filtros?.responsavel?.sap,
          user: props.filtros?.solicitante,
          data_inicial: props.filtros?.dataInicial,
          data_final: props.filtros?.dataFinal,
          comprado: props.filtros.compra?.value,
          com_comprador: props.filtros?.comprador?.value,
          numero:
            props.filtros?.numeroNecessidade == ""
              ? undefined
              : props.filtros?.numeroNecessidade,
        });

        $q.notify({
          message: "Exportado com sucesso",
          color: "positive",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
      } catch (error) {
        $q.notify({
          message: "Erro a o exportar",
          color: "negative",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
      }
    };

    watch(
      () => pagination.value.page,
      () => {
        disable.value = true;
        handleRequest();
      }
    );

    watch(
      () => props.atualizar,
      () => {
        getDados();
      }
    );

    watch(
      () => props.Produto,
      () => {
        getDados();
      }
    );

    watch(
      () => props.Responsavel,
      () => {
        getDados();
      }
    );

    watch(
      () => props.Solicitante,
      () => {
        getDados();
      }
    );

    watch(
      () => filtrar.value,
      () => {
        handleRequest();
      }
    );

    watch(
      () => store.state.org.unidadeData,
      () => {
        getDados();
      }
    );

    return {
      pagination,
      rows,
      disable,
      columns,
      filtrar,
      getDados,
      handleRequest,
      pagesNumber: computed(() =>
        Math.ceil(pagination.value.rowsNumber / pagination.value.rowsPerPage)
      ),
      compra,
      exportar,
      formatQuantidade,
    };
  },
};
</script>

<style scoped>
.align {
  align-items: center;
}
tbody tr td {
  white-space: pre-wrap;
}
</style>
